import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  // console.log("🚀 ScrollToTop mounted");

  useEffect(() => {
    // console.log("⏫ Scroll triggered to:", pathname);

    // Intenta hacer scroll en window y en root
    // window.scrollTo(0, 0);
     window.scrollTo({ top: 0, behavior: "smooth" });
    const root = document.getElementById("root");
    // root?.scrollTo(0, 0);
    root?.scrollTo({ top: 0, behavior: "smooth" }); // smooth, auto --> esto puede no funcionar en todos los navegadores
    // root?.scrollTo({ top: 0, behavior: "smooth" }); // smooth, auto --> esto puede no funcionar en todos los navegadores

  }, [pathname]);

  return null;
};

export default ScrollToTop;

